import { CountUp } from 'countup.js';

const countElements = document.getElementsByClassName('count-up');
const countElementsDecimal = document.getElementsByClassName('count-up-decimal');


if (countElements.length) {
  Array.from(countElements).forEach((element) => {
    const countUpNr = element.textContent;
    const elementCountUp = new CountUp(element, countUpNr, { separator: "'"});
    const observer = new IntersectionObserver((entries, observer) => {
      const entry = entries[0];

      if (entry.isIntersecting) {
        !elementCountUp.error ? elementCountUp.start() : console.error(elementCountUp.error);
      }
    });

    observer.observe(element);

  });
}

// with . -> as decimals
if (countElementsDecimal.length) {
  Array.from(countElementsDecimal).forEach((element) => {
    const countUpNr = element.textContent;
    const elementCountUp = new CountUp(element, countUpNr, { separator: "'", decimalPlaces: 2 });
    const observer = new IntersectionObserver((entries, observer) => {
      const entry = entries[0];

      if (entry.isIntersecting) {
        !elementCountUp.error ? elementCountUp.start() : console.error(elementCountUp.error);
      }
    });

    observer.observe(element);

  });
}


// fit numbers to h3 container
const fitTitles = document.querySelectorAll('.fittext');

if (fitTitles.length) {
  Array.from(fitTitles).map((item) => {
    fitText(item, 0.7);
  });
}